import { ref } from 'vue'

export function useIO() {
  const output = ref([])
  const scroller = ref(null)

  function nextTickScroll() {
    requestAnimationFrame(() => {
      if (scroller.value) scroller.value.scrollTop = scroller.value.scrollHeight
    })
  }

  function printLine(line) {
    output.value.push(line == null ? '' : String(line))
    nextTickScroll()
  }

  function printBlock(lines) { (lines || []).forEach(l => printLine(l)) }

  function printStructuredLines(lines) {
    (lines || []).forEach((line) => {
      if (typeof line === 'string') {
        output.value.push(line)
      } else if (line && Array.isArray(line.segments)) {
        output.value.push({ segments: line.segments.map(s => ({ text: String(s.text || ''), class: s.class || null, href: s.href || null })) })
      }
    })
    nextTickScroll()
  }

  return { output, scroller, printLine, printBlock, printStructuredLines, nextTickScroll }
}

